import { createSignatureV2EntryTicket, getSignatureV2Workflow } from '@/api/signatureV2.api';
import { canUseSignatureV2StepAction } from './actions';

export async function openInvitedSigningEntry(workflowId: string, stepValue: string | null) {
  if (!stepValue || !/^[1-9]\d*$/.test(stepValue) || !Number.isSafeInteger(Number(stepValue))) {
    throw new Error('invitation_invalid');
  }
  const workflow = await getSignatureV2Workflow(workflowId);
  const step = workflow.steps.find((item) => item.id === Number(stepValue));
  if (!step || step.status !== 'actionable' || workflow.current_step?.id !== step.id) {
    throw new Error('signing_entry_not_actionable');
  }
  if (!canUseSignatureV2StepAction(workflow, step, 'open_signing_entry')) {
    throw new Error('signing_entry_forbidden');
  }
  // 後端再次檢查登入 signer、版本與簽署順序；舊信不可改開下一位 signer。
  return createSignatureV2EntryTicket(workflow.uuid, step.id, workflow.version);
}
